import { CreateOrderState } from "../rootReducerTypes";
import {
    CreateOrderActionTypes,
    UPDATE_ORDER_TO_CREATE,
    SET_SHOULD_SAVE_ORDER_LOCATION,
    UpdateOrderToCreateAction,
    SetSelectedCustomerAction,
    UpdateOrderToCreateActionPayload,
    SetShouldSaveOrderLocationAction,
    SetSelectedCustomerActionPayload,
    SET_SELECTED_CUSTOMER,
    SetSelectedAssetActionPayload,
    SetSelectedAssetAction,
    SET_SELECTED_ASSET,
    UpdateOrderRequiredFieldSettingsPayload,
    UpdateOrderRequiredFieldSettingsAction,
    UPDATE_ORDER_REQUIRED_FIELD_SETTINGS
} from '../reducersAndActionsType/createOrderActionAndReducerTypes';


export function updateOrderToCreate(orderToCreatePayload: UpdateOrderToCreateActionPayload): UpdateOrderToCreateAction {
    return {
        type: UPDATE_ORDER_TO_CREATE,
        updateOrderToCreateActionPayload: orderToCreatePayload,
    };
}

export function setShouldSaveOrderLocation(shouldSaveOrderLocation: boolean): SetShouldSaveOrderLocationAction {
    return {
        type: SET_SHOULD_SAVE_ORDER_LOCATION,
        shouldSaveOrderLocation
    };
}

export function setSelectedCustomer(selectedCustomerPayload: SetSelectedCustomerActionPayload): SetSelectedCustomerAction {
    return {
        type: SET_SELECTED_CUSTOMER,
        setSelectedCustomerPayload: selectedCustomerPayload
    };
}

export function setSelectedAsset(selectedAssetPayload: SetSelectedAssetActionPayload): SetSelectedAssetAction {
    return {
        type: SET_SELECTED_ASSET,
        setSelectedAssetPayload: selectedAssetPayload
    };
}

export function updateOrderRequiredFieldSettings(orderRequiredFieldSettingsPayload: UpdateOrderRequiredFieldSettingsPayload): UpdateOrderRequiredFieldSettingsAction {
    return {
        type: UPDATE_ORDER_REQUIRED_FIELD_SETTINGS,
        updateOrderRequiredFieldSettingsPayload: orderRequiredFieldSettingsPayload,
    };
}

export default function createOrderReducer(state: CreateOrderState = initialState, action: CreateOrderActionTypes): CreateOrderState {
    switch (action.type) {
        case UPDATE_ORDER_TO_CREATE:
            return {
                ...state,
                orderToCreate: action.updateOrderToCreateActionPayload.orderToCreate
            };
        case SET_SHOULD_SAVE_ORDER_LOCATION:
            return {
                ...state,
                shouldSaveOrderLocation: action.shouldSaveOrderLocation
            };
        case SET_SELECTED_CUSTOMER:
            return {
                ...state,
                selectedCustomer: action.setSelectedCustomerPayload.selectedCustomer
            };
        case SET_SELECTED_ASSET:
            return {
                ...state,
                selectedAsset: action.setSelectedAssetPayload.selectedAsset
            };
        case UPDATE_ORDER_REQUIRED_FIELD_SETTINGS:
            return {
                ...state,
                orderRequiredFieldSettings: action.updateOrderRequiredFieldSettingsPayload.orderRequiredFieldSettings
            };
        default:
            return state;
    }
}

export const initialState: CreateOrderState = {
    orderToCreate: {
        customerRequestedDate: null,
        address: {
            street: '',
            houseNo: '',
            address2: '',
            postalCode: '',
            country: '',
            city: '',
            formattedAddress: ''
        },
        urgent: false,
        orderName: '',
        webUserContactRoleName: '',
        webUserContactFirstName: "",
        webUserContactLastName: ""
    },
    shouldSaveOrderLocation: false,
    orderRequiredFieldSettings: {
        isCustomerReferenceFieldRequired: false,
        isMainOrderFieldRequired: false,
        isRequisitionFieldRequired: false
    }
};